import { render, staticRenderFns } from "./StepPolicySignature.vue?vue&type=template&id=11afdaad&scoped=true"
import script from "./StepPolicySignature.vue?vue&type=script&lang=js"
export * from "./StepPolicySignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11afdaad",
  null
  
)

export default component.exports